import api from '@/api'

const store = {
  state: {
    dataStoreDeliverySchedule: [],
    pagingStoreDeliverySchedule: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingStoreDeliverySchedule: {
      byField: '',
      isDesc: false
    },
    filteringStoreDeliverySchedule: {
      outletCode: null,
      orderType: null,
      status: null,
      beginDate: null,
      endDate: null,
      beginDay: null,
      endDay: null,
      beginHour: null,
      endHour: null
    }
  },

  mutations: {
    SET_STOREDELIVERYSCHEDULE: (state, payload) => {
      state.dataStoreDeliverySchedule = payload
    },
    SET_PAGING_PAGE_STOREDELIVERYSCHEDULE: (state, payload) => {
      state.pagingStoreDeliverySchedule.page = payload
    },
    SET_PAGING_TOTAL_STOREDELIVERYSCHEDULE: (state, payload) => {
      state.pagingStoreDeliverySchedule.total = payload
    },
    SET_SORTING_STOREDELIVERYSCHEDULE: (state, payload) => {
      state.sortingStoreDeliverySchedule = payload
    },
    SET_FILTERING_STOREDELIVERYSCHEDULE: (state, payload) => {
      state.filteringStoreDeliverySchedule = payload
    }
  },

  getters: {
    SortingStoreDeliverySchedule: state => state.sortingStoreDeliverySchedule,
    FilteringStoreDeliverySchedule: state =>
      state.filteringStoreDeliverySchedule,
    PagingStoreDeliverySchedule: state => state.pagingStoreDeliverySchedule,
    GetAllStoreDeliverySchedule: state => state.dataStoreDeliverySchedule,
    GetOneStoreDeliverySchedule: state => id =>
      state.dataStoreDeliverySchedule.find(
        dataStoreDeliverySchedule => dataStoreDeliverySchedule.id === id
      )
  },

  actions: {
    async UpdateSortingStoreDeliverySchedule({ commit, dispatch }, payload) {
      commit('SET_SORTING_STOREDELIVERYSCHEDULE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllStoreDeliverySchedule')
    },

    async UpdateFilteringStoreDeliverySchedule(
      { commit, dispatch },
      isResetField
    ) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_STOREDELIVERYSCHEDULE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_STOREDELIVERYSCHEDULE', 1)
      dispatch('GetAllStoreDeliverySchedule')
    },

    async GetAllStoreDeliverySchedule({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllStoreDeliverySchedule(
          state.pagingStoreDeliverySchedule,
          state.sortingStoreDeliverySchedule,
          state.filteringStoreDeliverySchedule
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit(
          'SET_PAGING_TOTAL_STOREDELIVERYSCHEDULE',
          result.headers['data-length']
        )
        commit('SET_STOREDELIVERYSCHEDULE', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateStoreDeliverySchedule({ dispatch }, payload) {
      try {
        const { data } = await api.CreateStoreDeliverySchedule(payload)
        dispatch('GetAllStoreDeliverySchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateStoreDeliverySchedule({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateStoreDeliverySchedule(
          payload.id,
          payload
        )
        dispatch('GetAllStoreDeliverySchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteStoreDeliverySchedule({ dispatch }, id) {
      try {
        const { data } = await api.DeleteStoreDeliverySchedule(id)
        dispatch('GetAllStoreDeliverySchedule')
        return data
      } catch (e) {
        return e.response
      }
    }
  }
}

export default store
